import { useEffect, useRef } from "react";

// A modal dialog closes on Escape and takes focus when it opens (into its first control), then gives it
// back to whatever had it when it closes, so keyboard and screen-reader users are not left behind.
export function useDialog<T extends HTMLElement>(onClose: () => void) {
  const ref = useRef<T>(null);
  const close = useRef(onClose);
  useEffect(() => { close.current = onClose; }, [onClose]);
  useEffect(() => {
    const before = document.activeElement as HTMLElement | null;
    const first = ref.current?.querySelector<HTMLElement>("input, select, textarea, button:not([aria-label^='Close']), [href], [tabindex]:not([tabindex='-1'])");
    (first ?? ref.current)?.focus();
    const onKey = (event: KeyboardEvent) => { if (event.key === "Escape") { event.stopPropagation(); close.current(); } };
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("keydown", onKey); before?.focus?.(); };
  }, []);
  return ref;
}
